
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"49","height":"49","rx":"24.5","fill":"white","stroke":"white"}}),_c('path',{attrs:{"d":"M29.0073 24.5009C29.0073 24.1413 28.8597 23.8032 28.5873 23.5456L22.4417 17.7336C21.8856 17.2076 20.9776 17.2076 20.4215 17.7336C19.8654 18.2595 19.8654 19.1182 20.4215 19.6441L25.5571 24.5009L20.4215 29.3577C20.1491 29.6099 20.0016 29.9534 20.0016 30.3129C20.0016 30.6725 20.1491 31.0106 20.4215 31.2682C20.9776 31.7941 21.8856 31.7941 22.4417 31.2682L28.5873 25.4561C28.8597 25.1985 29.0073 24.8604 29.0073 24.5009Z"}})])
          )
        }
      }
    